<template>
  <b-sidebar
    right
    shadow
    backdrop
    v-model="showSidebar"
    width="90%"
    @change="visibleChanged"
    no-header
    prop
  >
    <media-list
      :finder="true"
      :fromCoreEdit="fromCoreEdit"
      @on-attach="$emit('on-attach', $event)"
    ></media-list>
  </b-sidebar>
</template>

<script>
import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";

export default {
  components: {
    mediaList: () => ({
      component: import("@/views/modules/media"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    })
  },
  props: {
    fromCoreEdit: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      loading: true,
      taskObj: {
        loaded: false,
        columns: [],
        task: {}
      },
      showSidebar: false,
      nestedSidebar: false,
      idNested: 0
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.showSidebar = true;
    },
    visibleChanged(e) {
      if (!e) {
        Object.assign(this.$data, this.$options.data());
        this.$emit("on-task-close");
      }
    }
  }
};
</script>

<style></style>
